<div class="progress-bar" [ngClass]="getClass()">
	<span class="progress-bar-fill" [ngStyle]="getStyle()"> </span>
</div>
<span class="tooltip" style="--move-to: {{percentageMoveTo}}" >{{ percentage }}%</span>
